import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import * as React from 'react'

import MobileAppPromotionDE from '../../../assets/app-promotion/mobile-app-promotion-de.png'
import MobileAppPromotionEN from '../../../assets/app-promotion/mobile-app-promotion-en.png'
import MobileAppPromotionES from '../../../assets/app-promotion/mobile-app-promotion-es.png'
import MobileAppPromotionFR from '../../../assets/app-promotion/mobile-app-promotion-fr.png'
import MobileAppPromotionIT from '../../../assets/app-promotion/mobile-app-promotion-it.png'
import MobileAppPromotionNL from '../../../assets/app-promotion/mobile-app-promotion-nl.png'
import { useIntl } from '../../localization/react'

const useStyles = makeStyles({
  image: (props: Pick<Props, 'size'>) => ({
    height: props.size === 'large' ? 444 : 285,
  }),
})

interface Props {
  size?: 'normal' | 'large'
  className?: string
}

const AppPromotionImage: React.FC<React.PropsWithChildren<Props>> = ({ size = 'normal', className }) => {
  const intl = useIntl()
  const classes = useStyles({ size })
  const language = intl.context.locale.loaded

  switch (language.toLowerCase()) {
    case 'de':
      return (
        <img src={MobileAppPromotionDE as string} alt="Mobile App" className={classNames(classes.image, className)} />
      )
    case 'es':
      return (
        <img src={MobileAppPromotionES as string} alt="Mobile App" className={classNames(classes.image, className)} />
      )
    case 'fr':
      return (
        <img src={MobileAppPromotionFR as string} alt="Mobile App" className={classNames(classes.image, className)} />
      )
    case 'nl':
      return (
        <img src={MobileAppPromotionNL as string} alt="Mobile App" className={classNames(classes.image, className)} />
      )
    case 'it':
      return (
        <img src={MobileAppPromotionIT as string} alt="Mobile App" className={classNames(classes.image, className)} />
      )
    default:
      return (
        <img src={MobileAppPromotionEN as string} alt="Mobile App" className={classNames(classes.image, className)} />
      )
  }
}

export default AppPromotionImage
